export enum ESide {
  BUY = 0,
  SELL = 1,
  UNSET = 2,
}

export interface Spread {
  bid: number;
  ask: number;
  mid: number;
}

export interface WatchlistEntryOptions {
  notifications: boolean;
  sounds: number;
  showBid: boolean;
  showAsk: boolean;
}

// Records: what we want to store
export interface WatchlistRecord {
  id: string;
  symbol: string;
  tenorCode: string;
  tenor: string;
  targetPrice: number;
  side: ESide;
  targetPriceHit: boolean;
  targetPriceHitTime: number;
  options: WatchlistEntryOptions;
  subscriptionKey: string;
  hasData: boolean;
  hasSpreadData?: boolean;
  canTrade?: boolean;
}

// Updates: live updates to values, don't want these to persist
export interface WatchlistRecordUpdate {
  id: string;
  referencePrice: number;
  currentPrice: number;
  lastPrice: number;
  spread: Spread;
  hasUpdated: boolean;
}

// Entries: union of the above
export type WatchlistEntry = WatchlistRecord & WatchlistRecordUpdate;

export interface WatchlistPayload {
  records: WatchlistRecord[];
}

// Discards the 'update' part for saving in the widget
export function getWatchlistRecordFromEntry(entry: WatchlistEntry): WatchlistRecord {
  const {
    id,
    symbol,
    tenorCode,
    tenor,
    targetPrice,
    side,
    targetPriceHit,
    targetPriceHitTime,
    options,
    subscriptionKey,
    hasData,
    hasSpreadData,
    canTrade,
  } = entry;
  return {
    id,
    symbol,
    tenorCode,
    tenor,
    targetPrice,
    side,
    targetPriceHit,
    targetPriceHitTime,
    options,
    subscriptionKey,
    hasData,
    hasSpreadData,
    canTrade,
  };
}

// From a record saved in the widget, add a blank update
export function getWatchlistEntryFromRecord(entry: WatchlistRecord): WatchlistEntry {
  return {
    ...entry,
    referencePrice: 0,
    currentPrice: 0,
    lastPrice: 0,
    spread: {
      mid: 0,
      bid: 0,
      ask: 0,
    },
    hasUpdated: false,
  };
}
